import React from "react";
import { View, Image, Platform } from "react-native";
import { useAssets } from "presto-react-components";
import config from "@presto-common/config";

export default function Logo() {
  const { images: Images } = useAssets();

  return (
    <View
      style={{
        flexDirection: "row",
        justifyContent: "flex-start",
        marginLeft: Platform.OS === "web" ? 0 : 20,
      }}
    >
      <Image
        source={Images.textLogo2}
        resizeMode="contain"
        style={{
          height: config.app === "simplyveggie" ? 40 : 34,
          width: config.app === "simplyveggie" ? 60 : 110,
          marginLeft: Platform.OS === "web" ? 0 : -15,
          minWidth: Platform.OS === "web" ? 0 : 0,
        }}
      />
    </View>
  );
}
